import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Renders route only if user is authenticated. Otherwise it redirects to login
export default function AuthRoute({ path, render }) {
  const associate = useSelector((state) => state.associates);
  const domainTarget = useSelector((state) => state.app.domainTarget);

  const allowedRoles =
    domainTarget === 'APPCUSTOMER'
      ? ['customer']
      : ['associate', 'cashier', 'salesteamlead', 'bosssales', 'doorman', 'link', 'internalstaff', 'reseller'];
  const hasAllowedRole = (roles) => roles.some((role) => allowedRoles.includes(role));
  const roles = associate.roles;

  const renderRoute = (props) => {
    if (associate.authenticated) {
      if (!hasAllowedRole(roles) || associate.user.kycStatus === 'REJECTED') {
        return <Redirect to={{ pathname: '/unauthorized' }} />;
      }

      if (roles.includes('doorman')) {
        return render(props);
      }

      if (path !== '/' && associate.user.advantageNetworkStatus !== 'APPROVED') {
        return <Redirect to={{ pathname: '/' }} />;
      }

      // if (associate.user.kycStatus === 'INVALID' || associates.user.kycStatus === 'PENDING')
      //   return <Redirect to={{ pathname: '/kyc-start' }} />;
      // if (associate.user.kycStatus === 'REVALIDATION')
      //   return <Redirect to={{ pathname: '/sign-up-concierge-info' }} />;

      if (associate.user.needPasswordReset && path !== '/change-password') {
        return <Redirect to={{ pathname: '/change-password' }} />;
      } else {
        return render(props);
      }

      // } else if (
      //   !associate.user.firstLogin &&
      //   path !== '/welcome' &&
      //   path !== '/onboarding' &&
      //   !associate.user.needPasswordReset
      // ) {
      //   return <Redirect to={{ pathname: '/welcome' }} />;
    } else {
      return <Redirect to={{ pathname: '/login' }} />;
    }
  };
  return <Route exact path={path} render={renderRoute} />;
}
